export interface SitespectVariants {
  [variantId: number]: boolean
}

export interface SitespectCampaigns {
  [campaignId: number]: number[]
}

export interface CampaignsAndVariants {
  variants: SitespectVariants
  campaigns: SitespectCampaigns
}

export default function getCampaignsAndVariants(): CampaignsAndVariants {
  if (typeof window.sitespect !== 'string') {
    return { campaigns: {}, variants: {} }
  }

  return window.sitespect
    .split('|')
    .map((campaignAndVariant = '') => campaignAndVariant.split('='))
    .reduce(
      (previous, [campaign = '', variant = '']) => {
        const campaignId = +campaign.substring(1)
        const [variantString, isInVariant] = variant.split('/')
        const variantId = +variantString.substring(2)

        return {
          campaigns: {
            ...previous.campaigns,
            [campaignId]: [...(previous.campaigns[campaignId] || []), variantId]
          },
          variants: {
            ...previous.variants,
            [variantId]: +isInVariant === 1
          }
        }
      },
      { variants: {}, campaigns: {} }
    )
}
